import { Link } from "@tanstack/react-router";
import type { JobCategoryWithTags } from "@/types/db";
import type { LocationsResponse } from "@/lib/locations";
import EmailCaptureForm from "@/components/common/emailCaptureForm";

interface FooterProps {
  // Retained so the root layout can keep passing these once locations /
  // categories re-enter the footer. Currently unused — the header mega-menu
  // surfaces the same taxonomy sitewide.
  jobCategoriesWithTags?: JobCategoryWithTags[];
  locations?: LocationsResponse;
}

const sectionHeadingClass =
  "mb-3 text-xs font-semibold tracking-wide text-orange-200 uppercase";
const linkClass = "text-white/70 transition-colors hover:text-white";

export default function Footer(_props: FooterProps) {
  return (
    <footer
      className="bg-polaris-navy mt-20 px-4 py-16 text-white sm:px-6 lg:px-8"
      id="footer"
      aria-labelledby="footer-heading"
    >
      <h2 id="footer-heading" className="sr-only">
        Site footer
      </h2>
      <div className="mx-auto max-w-5xl">
        <div className="flex flex-col gap-12 lg:flex-row lg:items-start lg:gap-24">
          <div className="lg:w-72 lg:shrink-0">
            <EmailCaptureForm variant="footer" />
          </div>

          {/* Flex-wrap instead of a fixed grid — columns size to their
              content and wrap naturally on narrow viewports. */}
          <nav
            aria-label="Footer"
            className="flex flex-wrap gap-x-12 gap-y-8 text-sm sm:gap-x-16"
          >
            <div>
              <h3 className={sectionHeadingClass}>Browse</h3>
              <ul className="space-y-2" role="list">
                <li>
                  <Link to="/search" className={linkClass}>
                    Search all jobs
                  </Link>
                </li>
                <li>
                  <Link to="/remote" className={linkClass}>
                    Remote data jobs
                  </Link>
                </li>
                <li>
                  <Link to="/locations" className={linkClass}>
                    Jobs by location
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h3 className={sectionHeadingClass}>For Businesses</h3>
              <ul className="space-y-2" role="list">
                <li>
                  <Link to="/post-job" className={linkClass}>
                    Post a Job
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h3 className={sectionHeadingClass}>Resources</h3>
              <ul className="space-y-2" role="list">
                <li>
                  <Link to="/resources/guides" className={linkClass}>
                    Guides
                  </Link>
                </li>
              </ul>
            </div>
          </nav>
        </div>

        <div className="mt-12 border-t border-white/10 pt-6 text-center text-xs text-white/40">
          &copy; {new Date().getFullYear()} Data First Jobs
        </div>
      </div>
    </footer>
  );
}
